<template>
	<div
		v-if="!errorLoading"
		class="adbutler-ad"
		:class="{ 'has-loaded': loaded }"
	>
		<div
			v-if="isIframe"
		>
			<!-- eslint-disable vue/no-v-html -->
			<div
				v-html="iframeCode"
			/>
		</div>
		<component
			:is="link ? 'a' : 'div'"
			v-else
			:href="link"
			:target="link ? '_blank' : null"
			rel="noopener"
		>
			<img
				v-if="imageUrl"
				ref="image"
				:style="dynamicStyle"
				:src="imageUrl"
				:alt="name || ''"
				class="adbutler-ad__image"
				data-testid="adbutler-image"
			>
		</component>
	</div>
</template>

<script>
import AdsMixin from '@shared/js/mixins/AdsMixin';

export default {
	name:   'AdButlerAd',
	mixins: [AdsMixin],
	props:  {
		ad: {
			type:     Object,
			required: true,
		},
		fixedSize: {
			type:    Boolean,
			default: true,
		},
	},
	data() {
		return {
			imageUrl:         null,
			name:             null,
			link:             null,
			isIframe:         false,
			iframeCode:       null,
			width:            null,
			height:           null,
			adRefreshTimeout: null,
			errorLoading:     false,
			loaded:           false,
		};
	},
	computed: {
		dynamicStyle() {
			return !this.fixedSize
				? {}
				: {
					width:  this.width !== null ? this.width : 'auto',
					height: this.height == null || this.isAdbutlerMobile ? 'auto' : this.height,
				};
		},
	},
	mounted() {
		this.loadAdButlerAd();
	},
	beforeDestroy() {
		if (this.adRefreshTimeout) {
			clearTimeout(this.adRefreshTimeout);
		}
	},
	methods: {
		loadAdButlerAd() {
			this.fetchAdbutlerAd(this.adButlerCallback);
		},
		adButlerCallback(adButlerResponse) {
			// Error handling
			if (!adButlerResponse || adButlerResponse.placements?.placement_1 === undefined) {
				this.errorLoading = true;
				return;
			}
			if (adButlerResponse.status === 'SUCCESS' && adButlerResponse.placements?.placement_1) {
				const placement = adButlerResponse.placements?.placement_1;

				if (placement.body) {
					this.iframeCode = placement.body;
					this.isIframe = true;
					this.hasLoaded();
				} else if (placement.image_url) {
					this.imageUrl = placement.image_url;
					this.link = placement.redirect_url;
					this.width = placement.width + 'px';
					this.height = placement.height + 'px';

					this.$nextTick(() => {
						if (this.$refs.image) {
							this.$refs.image.addEventListener('load', () => {
								this.hasLoaded(placement);
							});
						}
					});
				}

				if (parseInt(placement.refresh_time) > 0) {
					this.adRefreshTimeout = setTimeout(() => {
						this.fetchAdbutlerAd(this.adButlerCallback);
					}, parseInt(placement.refresh_time) * 1000);
				}
			}
		},
		hasLoaded(placement) {
			this.loaded = true;
			this.$emit('loaded', placement);
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@shared/sass/shared-variables';

.adbutler-ad {
	max-width: 100%;

	&.has-loaded::after {
		display: block;
		content: attr(data-text);
		position: absolute;
		right: 2px;
		bottom: calc(100% - -8px);
		font-size: 14px; // stylelint-disable-line sh-waqar/declaration-use-variable, property-disallowed-list
		color: var(--color-grey-300);
	}
}

.adbutler-ad__image {
	width: 100%;
	display: block;

	&.-mobile {
		display: block;
		width: auto;

		@include size(sm-up) {
			display: none;
		}
	}

	.adbutler-ad.-has-mobile-image & {
		&.-desktop {
			@include size(xs-only) {
				display: none;
			}
		}
	}
}

</style>
